import { create } from 'apisauce';
import { getCookie } from './cookie';

const instance = create({ baseURL: import.meta.env.REACT_APP_API_ROOT, withCredentials: true });

instance.axiosInstance.interceptors.request.use((config) => {
  const token = getCookie('axl_shipment_token');
  config.headers['Authorization'] = `TToken AXL_${token}`;

  return config;
});

export const updateLocations = (trackingCode, shipmentID, data) => instance.post(`delivery/${trackingCode}/${shipmentID}/update-locations`, data);
export const updateQuestionnaire = (trackingCode, shipmentID, data) =>
  instance.post(`delivery/${trackingCode}/${shipmentID}/update-questionnaire`, data);
export const getDropoffPosition = (addressType) => instance.get(`delivery/${addressType}/get-drop-off-position`);

export const updateDelivery = (trackingCode, shipmentID, params) => {
  const formData = new FormData();

  for (const key in params) {
    formData.append(key, params[key]);
  }

  return instance.post(`delivery/${trackingCode}/${shipmentID}/update`, formData, { headers: { 'Content-Type': undefined } });
};

export default instance;
